import { render, staticRenderFns } from "./AccountPwd.vue?vue&type=template&id=4c07300b"
import script from "./AccountPwd.vue?vue&type=script&lang=js"
export * from "./AccountPwd.vue?vue&type=script&lang=js"
import style0 from "./AccountPwd.vue?vue&type=style&index=0&id=4c07300b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports